import script from "./AppMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=ef9b0226&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9b0226"]])

export default __exports__